/**
 * Starter templates barrel.
 *
 * Each raw board config is validated through BoardSchema at test time
 * (see templates.test.ts). At runtime these are loaded on demand when
 * the user selects a template from the onboarding bar.
 */
export { COMMUTER_BOARD_RAW } from './commuter.js';
export { SPORTS_FAN_BOARD_RAW } from './sports-fan.js';
export { INVESTOR_BOARD_RAW } from './investor.js';
export { PARENT_BOARD_RAW } from './parent.js';

import { COMMUTER_BOARD_RAW } from './commuter.js';
import { SPORTS_FAN_BOARD_RAW } from './sports-fan.js';
import { INVESTOR_BOARD_RAW } from './investor.js';
import { PARENT_BOARD_RAW } from './parent.js';

/** Map from template id (per analytics contract) to its raw board config. */
export const TEMPLATE_BOARDS = {
  commuter: COMMUTER_BOARD_RAW,
  sports_fan: SPORTS_FAN_BOARD_RAW,
  investor: INVESTOR_BOARD_RAW,
  parent: PARENT_BOARD_RAW,
} as const;

export type TemplateId = keyof typeof TEMPLATE_BOARDS;
